module.exports = __webpack_public_path__ + "img/report.bf1b6c81.svg";